import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const numberFormats = {
  de: {
    currency: {
      style: 'currency', currency: 'EUR'
    },
    decimal: {
      style: 'decimal'
    },
    currencyNoFractionDigits: {
      style: 'currency', currency: 'EUR', minimumFractionDigits: 0
    }
  },
  en: {
    currency: {
      style: 'currency', currency: 'EUR'
    },
    decimal: {
      style: 'decimal'
    },
    currencyNoFractionDigits: {
      style: 'currency', currency: 'EUR', minimumFractionDigits: 0
    }
  }
}

function loadLocaleMessages () {
  const locales = require.context('./lang', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
  numberFormats
})
